import React from "react";

const DatPublicAbout = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 py-12 bg-gray-900 text-gray-100 rounded-xl shadow-lg">
      {/* Company Overview */}
      <section className="mb-10">
        <h1 className="text-4xl font-bold mb-4 text-white">
          About Dialectix Pty Ltd
        </h1>
        <p className="text-lg mb-3">
          Dialectix Pty Ltd is an Australian company advancing reasoning systems
          for research, education, and enterprise.
        </p>
        <p className="text-lg mb-3">
          Our foundation is the <strong>Dialectical Analysis Theory</strong> — a
          structured approach to thinking that surfaces contradictions,
          clarifies assumptions, and reveals gaps in reasoning.
        </p>
        <p className="text-lg">
          DAT powers <strong>DAT Engine</strong>, a secure platform that helps
          users interrogate complex questions through transparent epistemic
          logic.
        </p>
      </section>

      {/* What is DAT */}
      <section className="mb-10">
        <h2 className="text-3xl font-semibold mb-3 text-white">What is DAT?</h2>
        <p className="text-lg mb-2">
          DAT is a theory for rigorous inquiry that challenges conventional
          thinking by:
        </p>
        <ul className="list-disc list-inside text-lg mb-4 space-y-1">
          <li>Validating contradictions</li>
          <li>Testing synthetic coherence</li>
          <li>Reframing structural assumptions</li>
          <li>Mapping resolution paths without shortcuts</li>
        </ul>
        <p className="text-lg mb-2">
          DAT Engine interrogates the logic behind any question; empirical,
          symbolic, or philosophical, by analysing if underlying claims hold or
          fail.
        </p>
        <p className="text-lg">
          In an era of fast answers, DAT slows thinking to enable better
          questions.
        </p>
      </section>

      {/* Accessing DAT */}
      <section className="mb-12">
        <h2 className="text-3xl font-semibold mb-3 text-white">
          Accessing DAT
        </h2>
        <p className="text-lg mb-2">
          DAT is available by invitation to universities, research groups, and
          enterprise partners.
        </p>
        <p className="text-lg">
          Request access via{" "}
          <a
            href="mailto:dat@dialectix.com.au"
            className="text-blue-400 underline hover:text-blue-300"
          >
            dat@dialectix.com.au
          </a>
        </p>
      </section>

      {/* Trust & Security Footnote */}
      <footer className="border-t border-gray-700 pt-6 mt-10 text-sm text-gray-400">
        <p className="mb-2">
          <strong>Trust &amp; Security:</strong> DAT Engine is hosted on{" "}
          <span className="text-gray-300">Google Firebase</span> with end-to-end
          HTTPS, modern TLS, and strict content-security headers (A+ rating).
        </p>
        <p className="mb-2">
          Access is <span className="text-gray-300">invite-only</span>, with{" "}
          <span className="text-gray-300">Firebase Authentication</span>{" "}
          protecting all sessions. No ads, trackers, or third-party scripts are
          loaded.
        </p>
        <p>
          The platform is designed for{" "}
          <span className="text-gray-300">
            research, education, and enterprise
          </span>
          , supporting institutional review and compliance.
        </p>

        {/* Extra footer line (smaller “footnote” text) */}
        <p className="mt-4 text-xs text-gray-500">
          Dialectix Pty Ltd — advancing intellectual honesty and epistemic
          clarity through Dialectical Analysis Theory.
        </p>
      </footer>
    </div>
  );
};

export default DatPublicAbout;
